import React, { useCallback } from 'react';
import createReducer from 'utils/createReducer';

const DispatchingContext = React.createContext();

// Initial State
const INIT_STATE = {
  selectedJourneys: [],
};

// Actions
const ADD_JOURNEY = 'ownership/ADD_JOURNEY';
const REMOVE_JOURNEY = 'ownership/REMOVE_JOURNEY';
const CLEAR_JOURNEYS = 'ownership/CLEAR_JOURNEYS';

// Reducers
const reducer = createReducer(INIT_STATE, {
  [ADD_JOURNEY](state, payload) {
    return {
      ...state,
      selectedJourneys: [...state.selectedJourneys, payload],
    };
  },
  [REMOVE_JOURNEY](state, payload) {
    return {
      ...state,
      selectedJourneys: state.selectedJourneys.filter((id) => String(id) !== String(payload)),
    };
  },
  [CLEAR_JOURNEYS](state) {
    return {
      ...state,
      selectedJourneys: [],
    };
  },
});

// Action creators
const add = (journeyId) => ({
  type: ADD_JOURNEY,
  payload: journeyId,
});

const remove = (journeyId) => ({
  type: REMOVE_JOURNEY,
  payload: journeyId,
});

const clear = () => ({
  type: CLEAR_JOURNEYS,
  payload: {},
});

export function DispatchingContextProvider(props) {
  const [state, dispatch] = React.useReducer(reducer, INIT_STATE);

  const { selectedJourneys } = state;

  const addJourney = useCallback((journeyId) => {
    dispatch(add(journeyId));
  }, []);

  const removeJourney = useCallback((journeyId) => {
    dispatch(remove(journeyId));
  }, []);

  const clearJourneys = useCallback(() => {
    dispatch(clear());
  }, []);

  const value = { selectedJourneys, addJourney, removeJourney, clearJourneys };

  return <DispatchingContext.Provider value={value}>{props.children}</DispatchingContext.Provider>;
}

export default DispatchingContext;
